import { render } from "./ParameterForm.vue?vue&type=template&id=5f0fd064"
import script from "./ParameterForm.vue?vue&type=script&lang=js"
export * from "./ParameterForm.vue?vue&type=script&lang=js"

import "./ParameterForm.vue?vue&type=style&index=0&id=5f0fd064&lang=css"

import exportComponent from "/codebuild/output/src2326401477/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__